import { useEffect } from "react";
import { useAppTranslations } from "./useAppTranslations";
import { GUEST_UID, useAllieAuth } from "./useAllieAuth";
import { useCompany } from "./useCompany";
import { config } from "../helpers";

export const useSupport = () => {
  const { loggedUser } = useAllieAuth();
  const { company } = useCompany();
  const { GUEST } = useAppTranslations();

  useEffect(() => {
    const getVerticalPadding = () => {
      const headerHeight = 65;
      const intercomHeight = 704;
      return Math.max(0, window.innerHeight - headerHeight - intercomHeight);
    };

    if (loggedUser && company) {
      (window as any).Intercom('update', {
        app_id: config.SUPPORT_APP_ID,
        user_id: loggedUser.id,
        name: loggedUser.id === GUEST_UID ? GUEST : loggedUser.name,
        email: loggedUser.email,
        phone: loggedUser.phone,
        role: loggedUser.role,
        user_hash: loggedUser.supportHash,
        company: { ...company, name: company.name.replace('-app', '') },
        custom_launcher_selector: '#intercom-button',
        hide_default_launcher: true,
        alignment: 'right',
        vertical_padding: getVerticalPadding(),
      });
    }
  }, [loggedUser, company]);
}
